import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="auth-shell d-flex align-items-center justify-content-center min-vh-100">
          <div className="auth-glass rounded-5 shadow-lg p-4 p-md-5 w-100" style={{ maxWidth: '520px' }}>
            <div className="text-center">
              <div className="auth-brand-icon rounded-circle shadow-sm mx-auto mb-3">TM</div>
              <h1 className="h3 fw-semibold mb-3">Something went wrong</h1>
              <p className="text-muted mb-4">
                An error occurred while loading the admin panel. Please refresh the page to try again.
              </p>
              <button
                className="btn btn-primary rounded-pill shadow-sm"
                onClick={() => window.location.reload()}
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
